
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import './Claim.scss';
import { useEffect, useState } from 'react';
import { User, UserRole, State } from '../types/indes';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import Edit from '@/assets/steam/edit.svg';
import { TableData } from '@/components/Table/TableData';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import Utils from '@/utils/util';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useGetUserRoleList } from '../api/getRefrences';
import { useGetProductList, useGetClaimList, useGetUsersListForClaim } from '@/features/Claim/api/getClaimList';
import TYPES, { CLAIM_STATUS } from '@/utils/constants';
import { QuotesFilter } from '@/components/Elements/QuotesFilter';
import UpdateClaim from '../components/updateClaim';
import { useGetClaimDetails } from '../api/getClaimDetails';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const Claim = () => {
  const [claimList, setClaimList] = useState<User[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
  const perPage = 10;
  const [searchString, setSearchString] = useState('');
  const [filteredList, setFilteredList] = useState<User[]>([]);
  const [productList, setProductList] = useState<any[]>();
  const useGetUsersMutation = useGetProductList();
  const useGetClaimMutation = useGetClaimList();
  const [roles, setRoles] = useState<UserRole[]>([]);
  const useGetUserRoleMutation = useGetUserRoleList();
  const [states, setStates] = useState<State[]>([]);
  const [editUserData, setEditUserData] = useState<any>(null);
  const [usersList, setUsersList] = useState<User[]>([]);
  const [allUserList, setAllUserlist] = useState<User[]>([]);
  const [filteredValue, setFilteredValue] = useState<any>();
  const [editClaim, setEditClaim] = useState<any>('')
  const useGetUsersMutations = useGetUsersListForClaim();
  const useGetClaimDetailsMutation = useGetClaimDetails();

  useEffect(() => {
    getProductList(1, true);
    getClaimList(1, true);
    getUserList(1)
    // getUserRoleList()
  }, []);

  const getUserList = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetUsersMutations.mutateAsync({
      page: pageIndex,
      perPage: 500,
      search: '',
      filter: { 'rolesId': [1, 2, 3, 4] },
    });
    setUsersList(res.list);
    const filteredList = res.list.filter((user: any) =>
      [2, 3, 4].includes(Number(user.userRoleId))
    );
    setAllUserlist(filteredList);


  };

  const getUserRoleList = async () => {
    const res = await useGetUserRoleMutation.mutateAsync({
      search: ''
    });
    if (res) {
      const filteredRoles = res.list.filter((item: any) => {
        const id = Number(item.id);
        return id !== 1 && id !== 5 && id !== 6;
      });
      setRoles(filteredRoles);

    }
  };

  const getProductList = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter,
    });

    setProductList(res?.list);
  };

  const getClaimList = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetClaimMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter: filter ? filter : filteredValue ? filteredValue : null,
    });

    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    if (reset) {
      setClaimList(res.list);
      setTableCurrentIndex(1);
      if (searchString) {
        setFilteredList(res.list);
      }
    } else {
      setClaimList(claimList.concat(res.list));
      setTableCurrentIndex(pageIndex);
    }
  };

  const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value;
    setSearchString(searchString);
    const res = await useGetClaimMutation.mutateAsync({
      page: 1,
      perPage: perPage,
      search: searchString,
    });
    setClaimList(res.list);
    if (searchString) {
      setFilteredList(res.list);
    } else {
      setFilteredList([]);
    }
    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
  };

  const actualList = filteredList.length ? filteredList : claimList;

  const onTableStateChange = (pageIndex: number) => {
    if (totalPages >= pageIndex) {
      getClaimList(pageIndex, true);
    }
  };

  const getStates = (location: any) => {
    if (location && location.length > 0) {
      const states = location.map((loc: any) => loc.state);
      const uniqueStates = Array.from(new Set(states.map((state: any) => state.id)))
        .map((id) => states.find((state: any) => state.id === id)?.name);

      const firstThreeStates = uniqueStates.slice(0, 2);
      const remainingCount = uniqueStates.length - 2;

      return {
        firstThreeStates,
        remainingCount: remainingCount > 0 ? remainingCount : 0,
      };
    }
    return { firstThreeStates: [], remainingCount: 0 };
  };

  const getStatusName = (statusId: any) => {
    if (statusId === CLAIM_STATUS.REQUESTED) {
      return 'Requested'
    } else if (statusId === CLAIM_STATUS.REJECTED) {
      return 'Rejected'
    } else if (statusId === CLAIM_STATUS.APPROVED) {
      return 'Approved'
    } else {
      return ''
    }
  }

  const getRoleName = (userRoleId: any) => {
    if (userRoleId === TYPES.SUPER_ADMIN) {
      return 'Super Admin'
    } else if (userRoleId === TYPES.SALES_EXECUTIVE) {
      return 'Sales Executive'
    } else if (userRoleId === TYPES.SALES_MANAGER) {
      return 'Sales Manager'
    } else if (userRoleId === TYPES.SALES_HEAD) {
      return 'Sales Head'
    } else if (userRoleId === TYPES.MARKETING) {
      return 'Marketing'
    } else if (userRoleId === TYPES.ACCOUNTS) {
      return 'Accounts'
    }

    else {
      return 'Super Admin'
    }
  }

  const ClaimStatus = [
    { id: 1, name: 'Requested' },
    { id: 2, name: 'Approved' },
    { id: 3, name: 'Rejected' },
  ]


  const getClaimDetailss = async (id: any, entry?: any) => {
    const res = await useGetClaimDetailsMutation.mutateAsync({
      id
    });
    if (res?.list) {
      const updatedClaim = { ...entry, claims: res.list || [] };
      setEditClaim(updatedClaim);
    }
  }

  return (
    <>

      <div className="users-list-container">
        <PageHeader title='Claims' description='' />
        <div className='search-container'>
          <div className='search-filter-container'>

            <span className="search-content">
              <SearchIcon />
              <input
                type="text"
                id="simple-search"
                placeholder="Search by name, title, price.."
                onChange={searchUser}
                className="steam-search"
              />
            </span>
            <div>
              <div className="action-btn">
                <QuotesFilter showInstitute={false} roles={ClaimStatus} usersList={allUserList} options={[]} onRoleSelect={(filter: any) => {
                  // if (filter) {
                  //   getClaimList(1, true, filter);
                  // } else {
                  //   getClaimList(1, true)
                  // }
                  if (filter) {
                    setTableCurrentIndex(1)
                    setTotalPages(0);
                    setFilteredValue(filter);
                    getClaimList(1, true, filter);
                  } else {
                    setTableCurrentIndex(1)
                    setTotalPages(0);
                    setFilteredValue(null);
                    getClaimList(1, true)
                  }
                }} showRoleFilter={false} />
              </div>
            </div>

          </div>
        </div>
        <div className="users-list petsked-table">
          {useGetUsersMutation.isLoading && !searchString && (
            <div className="h-full w-full flex items-center justify-center  ">
              <Lottie className="loading-loader-class" animationData={noDataAnimation} />
            </div>
          )}

          <TableData<any>
            data={actualList}
            columns={[
              {
                title: 'Requested By',
                field: 'name',
                Cell({ entry: { createdByUser } }) {
                  return (
                    <div className="users-container">
                      <div>
                        <InitialsAvatar name={createdByUser && createdByUser.name ? createdByUser.name : 'SA'} className="avatar" />
                      </div>
                      <div className="user-details-container">

                        <div className="user-tab-name">
                          <div className="name">{createdByUser?.name}</div>
                          <div className="email address">{createdByUser?.email}</div>
                        </div>
                      </div>
                    </div>
                  );
                },
              },

              {
                title: 'User Role',
                field: 'userRole',
                Cell({ entry: { createdByUser } }) {
                  return (
                    <div className="table-user-role">
                      {getRoleName(Number(createdByUser?.userRoleId))}

                    </div>
                  );
                },
              },
              {
                title: 'Title',
                field: 'userRole',
                Cell({ entry: { title } }) {
                  return (
                    <div className="table-user-role">
                      {title}

                    </div>
                  );
                },
              },
              // {
              //   title: 'Total claims',
              //   field: 'userRole',
              //   Cell({ entry: { claims } }) {
              //     return (
              //       <div className="table-user-role">
              //         {claims && claims.length} Claim

              //       </div>
              //     );
              //   },
              // },
              {
                title: 'Claimed Amt',
                field: 'phone',
                Cell({ entry: { requestedAmount } }) {
                  return (
                    <div className="table-contact">
                      {requestedAmount ? Utils.convertDealSize(requestedAmount) : 0}

                    </div>
                  );
                },
              },

              {
                title: 'Approved Amt',
                field: 'phone',
                Cell({ entry: { approvedAmount } }) {
                  return (
                    <div className="table-contact">
                      {approvedAmount ? Utils.convertDealSize(approvedAmount) : ''}

                    </div>
                  );
                },
              },

              {
                title: 'Status',
                field: 'phone',
                Cell({ entry: { statusId } }) {
                  return (
                    <div className={`table-contact ${getStatusName(Number(statusId)) === 'Approved' ? 'uploaded' : ''} ${getStatusName(Number(statusId)) === 'Rejected' ? 'rejected' : ''}`}>
                      {getStatusName(Number(statusId))}

                    </div>
                  );
                },
              },
              {
                title: 'Updated On',
                field: 'createdAt',
                Cell({ entry: { updatedAt, statusId, createdAt } }) {
                  return (
                    <div className="table-date">
                      {/* {Utils.formatDate(
                        updatedAt
                      )} */}

                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-id" className="service-provider-tooltip">
                            <div className="service-name">
                              {/* {getStatusName(Number(statusId)) === 'Approved' ? 'Approved on:' : getStatusName(Number(statusId)) === 'Rejected' ? 'Rejected on:' : 'Requested on:'} {Utils.formatDate(
                                getStatusName(Number(statusId)) === 'Approved' ? updatedAt : getStatusName(Number(statusId)) === 'Rejected' ? updatedAt : createdAt
                              )} */}
                               { 'Requested on:'} {Utils.formatDate( createdAt )}
                            </div>
                          </Tooltip>
                        }
                      >
                        <span
                          className="tooltip-owner-name default table-contact  font-vale"
                          style={{ cursor: 'pointer' }}
                        >
                          {Utils.formatDate(
                            updatedAt
                          )}
                        </span>
                      </OverlayTrigger>
                    </div>
                  );
                },
              },

              {
                title: 'Action',
                field: 'id',
                Cell({ entry }) {
                  return (
                    <div className="user-btn-container">

                      <div className="edit-btn" onClick={() => { getClaimDetailss(entry?.id, entry) }} >
                        <img src={Edit} />
                      </div>
                      {/* <div
                        className="view-btn"
                      >
                        <img src={Delete} />
                      </div> */}
                    </div>
                  );
                },
              },
            ]}
            tableInitialState={{
              tableTotalRecords: totalPages,
              tablePageIndex: tableCurrentIndex,
            }}
            onTableStateChange={onTableStateChange}
            showPagination={true}
            isDataLoading={useGetUsersMutation?.isLoading}
          />
        </div>


      </div>
      <UpdateClaim claimDetails={editClaim} open={editClaim ? true : false} onClose={() => { setEditClaim('') }} onConfirm={() => { setEditClaim(''); getClaimList(1, true) }} />

    </>
  );
};
